import { THEME_ART, THEME_COOKIE } from '@/shared/constants/theme';
import { artIconHref } from '@/shared/favicon';
import { themeScheme } from '@/shared/theme';
import { Theme } from '@/shared/types/user';

export { resolveTheme } from '@/shared/theme';

export const applyTheme = (theme: Theme): void => {
  const root = document.documentElement;
  const art = THEME_ART[theme];
  // Mute transitions during the swap so the UI recolors at once.
  root.classList.add('theme-changing');
  root.setAttribute('data-theme', theme);
  root.setAttribute('data-scheme', themeScheme(theme));
  root.setAttribute('data-art', art);
  root.getBoundingClientRect(); // reflow: commit colors before re-enabling transitions
  root.classList.remove('theme-changing');
  document
    .querySelectorAll<HTMLLinkElement>('link[rel~="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => {
      const href = link.getAttribute('href');
      const next = href && artIconHref(href, art);
      if (next && next !== href) {
        link.setAttribute('href', next);
      }
    });
  // Lets the server apply the theme before first paint (max-age = 1 year).
  document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
};
